import SearchIcon from '@mui/icons-material/Search'
import IconButton from '@mui/material/IconButton'
import InputBase from '@mui/material/InputBase'

interface Props {
  search: any
  onChange: any
  onSubmit: any
  onFocusInOut: any
}

const DocNameSearch = ({ search, onChange, onSubmit, onFocusInOut }: Props) => {
  const handleNameKeyDown = (e) => {
    if (e.key === 'Escape') {
      e.target.blur()
      onFocusInOut(false)
    }
    if (e.key === 'Enter') {
      e.target.blur()
      onSubmit(e)
    }
  }

  return (
    <>
      <InputBase
        style={{ margin: 0 }}
        fullWidth
        name="name"
        placeholder="文書を検索"
        inputProps={{
          'aria-label': 'search',
          onKeyUp: handleNameKeyDown,
        }}
        onFocus={() => onFocusInOut(true)}
        value={search.name}
        onChange={onChange}
        data-testid="search-input"
      />
      <IconButton onClick={onSubmit} aria-label="Search" data-testid="search-icon-button">
        <SearchIcon color="action" />
      </IconButton>
    </>
  )
}

export default DocNameSearch
